import * as UiTypes from "../types/ui.types";
import * as AuthTypes from "../types/auth.types";
import axiosInstance from "../../api";
import TokenService from "../../utility";
import { alertActions } from "./alert.actions";

export const generateToken = (userData: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  axiosInstance
    .post("invitation/invitelink", userData)
    .then((res) => {
      dispatch({
        type: AuthTypes.SET_INVITATION,
        payload: res.data,
      });
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      if (err.response.status === 0) {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: "Server Error. Please try later.",
        });
      } else {
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.error.toString(),
        });
      }
    });
};

export const clearInvitation = () => (dispatch: any) => {
  dispatch({ type: AuthTypes.CLEAR_INVITATION });
};

export const authenticateToken =
  (token: any, navigate: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: AuthTypes.LOADING_AUTHENTICATION });
    axiosInstance
      .get("invitation/token/" + token)
      .then((res) => {
        dispatch({
          type: AuthTypes.AUTHENTICATED_INVITATION,
          payload: res.data,
        });
        dispatch({
          type: AuthTypes.AUTHORIZATION_TOKEN_SUCCESS,
        });
      })
      .catch((err) => {
        dispatch({
          type: AuthTypes.CLEAR_INVITATION,
        });
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.error.toString(),
          });
        }
      });
  };

export const signUp =
  (userData: any, token: any, navigate: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    //dispatch({type:AuthTypes.SINGUP_USER});

    axiosInstance.defaults.headers.common = { Authorization: token };
    axiosInstance
      .post("auth/register", userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(
          alertActions.success(
            "You have signup successfully. Login to your account."
          )
        );
        navigate("/login");
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.message,
          });
          dispatch(alertActions.error(err.message));
        } else {
          if (err.response.data.details) {
            dispatch(
              alertActions.error(JSON.stringify(err.response.data.defaults))
            );
          } else {
            dispatch(alertActions.error(err.response.data.message));
          }

          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.message,
          });
        }
      });
  };

export const logIn =
  (userData: any, navigate: any, location: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    axiosInstance
      .post("auth/syslogin", userData)
      .then((res) => {
        TokenService.saveLocalAccessToken(res.data);
        dispatch({
          type: AuthTypes.SET_USER,
          payload: res.data.data,
        });
        dispatch({ type: UiTypes.CLEAR_ERRORS });
      })
      .catch((err) => {
      dispatch(alertActions.showError(err, "Error loging in."))
      }).finally(()=>{
    dispatch({ type: UiTypes.LOADING_UI_SUCCESS });
      })
  };

export const authenticatePasswordResetToken =
  (userData: any, navigate: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.CLEAR_ERRORS });
    dispatch({ type: AuthTypes.LOADING_AUTHENTICATION });
    axiosInstance
      .post("password_reset/validate_token/", { token: userData })
      .then((res) => {
        dispatch({
          type: AuthTypes.AUTHENTICATED_INVITATION,
          payload: res.data,
        });
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error("Reset password link has been expired."));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.error.toString(),
          });
        }
      });
  };

export const restPassword =
  (userData: any, navigate: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    dispatch({ type: AuthTypes.SINGUP_USER });
    axiosInstance
      .post("password_reset/confirm/", userData)
      .then((res) => {
        dispatch({ type: UiTypes.CLEAR_ERRORS });
        dispatch(
          alertActions.success(
            "Your password has been reset successfully. Login to your account."
          )
        );
        navigate("/login");
      })
      .catch((err) => {
        dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type: UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString(),
        });
      });
  };

export const sendInvitation = (userData: any) => (dispatch: any) => {
  dispatch({ type: UiTypes.LOADING_UI });
  const token: string = localStorage.getItem("token") ?? "";
  axiosInstance.defaults.headers.common = { Authorization: token };
  axiosInstance
    .post("invitation/invite", userData)
    .then((res) => {
      dispatch({
        type: AuthTypes.SEND_INVITATION,
        payload: res.data,
      });
      dispatch(alertActions.success(res.data.message));
      dispatch({ type: UiTypes.CLEAR_ERRORS });
    })
    .catch((err) => {
      dispatch({
        type: UiTypes.SET_ERRORS,
        payload: err.response.data.detail.toString(),
      });
    });
};

export const refreshToken = (accessToken: any) => (dispatch: any) => {
  dispatch({
    type: AuthTypes.REFRESH_TOKEN,
    payload: accessToken,
  });
};

export const sendPasswordLink =
  (userData: any, navigate: any) => (dispatch: any) => {
    dispatch({ type: UiTypes.LOADING_UI });
    axiosInstance
      .post("password_reset/", userData)
      .then((res) => {
        dispatch({
          type: AuthTypes.AUTHENTICATED_INVITATION,
          payload: res.data,
        });
        dispatch(
          alertActions.success(
            "We have e-mailed your password rest link.Please check your email."
          )
        );
        dispatch({ type: UiTypes.CLEAR_ERRORS });
      })
      .catch((err) => {
        if (err.response.status === 0) {
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: "Server Error. Please try later.",
          });
        } else {
          dispatch(alertActions.error(err.response.data.message));
          dispatch({
            type: UiTypes.SET_ERRORS,
            payload: err.response.data.message,
          });

          /* dispatch(alertActions.error(err.response.data.detail.toString()));
        dispatch({
          type:UiTypes.SET_ERRORS,
          payload: err.response.data.detail.toString()
        }) */
        }
      });
  };
